export default "__VITE_ASSET__dLowBysG__"